import * as React from 'react'
import {
  Tooltip,
  Typography,
  TypographyProps,
  TooltipProps,
} from '../../components'

export interface TypoTooltipProps
  extends Omit<TooltipProps, 'children' | 'title'> {
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title?: React.ReactNode
  /**
   * TypgraphyProps are props for 'Typography' component
   */
  TypgraphyProps?: Omit<TypographyProps, 'children'>
  /**
   * The content of the component.
   */
  children: React.ReactNode
}
/**
 * TypoTooltip -The TypoTooltip component serves as a wrapper component for tooltip when text overflow happens.
 */
export const TypoTooltip = React.forwardRef<HTMLDivElement, TypoTooltipProps>(
  (props, ref) => {
    const { TypgraphyProps, children, onOpen, ...other } = props
    let { title } = props
    const typographyRef = React.useRef<HTMLDivElement>(null)
    const [isContentOverflow, setIsContentOverflow] = React.useState(false)

    title = title ?? children

    return (
      <Tooltip
        onOpen={e => {
          setIsContentOverflow(
            typographyRef.current!.offsetWidth <
              typographyRef.current!.scrollWidth
          )
          onOpen?.(e)
        }}
        ref={ref}
        {...other}
        title={isContentOverflow ? title : ''}
      >
        <Typography ref={typographyRef} noWrap {...TypgraphyProps}>
          {children}
        </Typography>
      </Tooltip>
    )
  }
)

TypoTooltip.displayName = 'TypoTooltip'
